import React, { useState } from "react";
import { auth } from "./firebase";
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword
} from "firebase/auth";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSignup, setIsSignup] = useState(false);
  const [error, setError] = useState("");

  const handleAuth = async (e) => {
    e.preventDefault();
    setError("");

    try {
      if (isSignup) {
        await createUserWithEmailAndPassword(auth, email, password);
      } else {
        await signInWithEmailAndPassword(auth, email, password);
      }
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div style={styles.page}>
      <style>
        {`
          input::placeholder {
            color: #94A3B8;
            opacity: 1;
          }
        `}
      </style>

      <div style={styles.card}>
        <h1 style={styles.title}>TanSmartX FinOps</h1>
        <p style={styles.subtitle}>
          Secure SaaS login for cloud cost intelligence
        </p>

        <form onSubmit={handleAuth}>
          <input
            style={styles.input}
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            style={styles.input}
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          {error && <p style={styles.error}>{error}</p>}

          <button style={styles.button} type="submit">
            {isSignup ? "Create Account" : "Login"}
          </button>
        </form>

        <button
          style={styles.linkButton}
          onClick={() => setIsSignup(!isSignup)}
        >
          {isSignup
            ? "Already have an account? Login"
            : "New user? Create account"}
        </button>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #07111f, #0f172a)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Inter, Arial, sans-serif"
  },
  card: {
    width: "420px",
    background: "#ffffff",
    borderRadius: "20px",
    padding: "36px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.35)"
  },
  title: {
    margin: 0,
    fontSize: "30px",
    color: "#0f172a"
  },
  subtitle: {
    color: "#64748b",
    marginBottom: "28px"
  },
  input: {
    width: "100%",
    padding: "14px",
    marginBottom: "14px",
    borderRadius: "10px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#0f172a",
    caretColor: "#2563eb",
    fontSize: "15px",
    fontWeight: 600,
    boxSizing: "border-box",
    outline: "none"
  },
  button: {
    width: "100%",
    padding: "14px",
    borderRadius: "10px",
    border: "none",
    background: "#0f172a",
    color: "#ffffff",
    fontSize: "16px",
    fontWeight: "700",
    cursor: "pointer"
  },
  linkButton: {
    marginTop: "18px",
    background: "transparent",
    border: "none",
    color: "#2563eb",
    cursor: "pointer",
    fontSize: "14px"
  },
  error: {
    color: "#dc2626",
    fontSize: "13px"
  }
};